import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import responsiveStyles from './responsiveStyles.module.scss'

import axios from 'axios'
import { useParams } from 'react-router-dom'
import Notiflix, { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'

import { Wrapper } from '../../reusable'
import FloatingInfoBox from '../../reusable/FloatingInfoBox'
import { ContactDetails, Person, Address, Review } from '../../formParts'
// import { Review } from '../../formParts/review/index'

// import stepArrow from "../../../assets/step-arrow2.svg";
import stepArrow from '../../../assets/step-arrow2-black.svg'

import { SaveValueInterface } from '../../../interfaces'
import { fieldValidation, sectionValidation, uploadDataToServer, uploadFileToServer } from '../../../helpers'
import { UploadDocuments } from '../../formParts/upload'
import { Complete } from '../../formParts/complete'
import { useUpdateClaimData } from '../../../claimProvider'
import { SignatureSentinel } from '../../formParts/signatureSentinel'
import NewsBanner from '../../newsBanner'
import EligibilitySection from '../../EligibilitySection'
import DottedBackground from '../../dottedBackground'
import { ft, gbn, itv, skyNews, theSun, bbc, dm } from '../../../assets/newsOutlets'
import { OpenBankingStep } from '../../formParts/openBanking'
const newsItems = [
    {
        id: 1,
        // companyName: 'ITV',
        image: itv,
    },
    {
        id: 2,
        // headline: 'As seen on BBC News',
        // companyName: 'BBC News',
        image: bbc,
    },
    {
        id: 3,
        // companyName: 'Sky News',
        image: skyNews,
    },
    {
        id: 4,
        // headline: 'As seen in the Financial Times',
        // companyName: 'Financial Times',
        image: ft,
    },
    {
        id: 5,
        // companyName: 'Daily Mail',
        image: dm,
    },
    {
        id: 6,
        // headline: 'As seen in the Sun',
        // companyName: 'The Sun',
        image: theSun,
    },
    {
        id: 7,
        // companyName: 'GB News',
        image: gbn,
    },
]

const steps = [
    {
        text: 'Your Details',
        transitionPoint: 0,
        step: 1,
    },
    {
        text: 'Review & Sign',
        transitionPoint: 2,
        step: 2,
    },
    {
        text: 'Complete Application',
        transitionPoint: 4,
        step: 3,
    },
]

const LEAD_SOURCE = window.location.href
const LEAD_ORIGIN = 'webform_MFC'

// Set to true in local dev to skip the lead upload API call and inject mock signing data
// so the signature step renders without a real backend submission (re-enable before pushing)
const SKIP_LEAD_UPLOAD = false
function ClaimFormMailReferral() {
    const [claimObject, setClaimObject] = useState<any>({
        leadOrigin: LEAD_ORIGIN,
        leadSource: LEAD_SOURCE,
    })
    const [groupsComplete, setGroupsComplete] = useState(0)
    const [activeGroup, setActiveGroup] = useState('person')
    const [displayedPercentage, setDisplayedPercentage] = useState(0)
    const [actualPercentage, setActualPercentage] = useState(0)
    const [showInfoBox, setShowInfoBox] = useState(true)
    // Holds the claimData returned by the first successful lead submission so that
    // returning to the signature step (e.g. browser back from e-sign) doesn't
    // re-post the lead and trip the backend duplicate-client guard.
    const [submittedClaimData, setSubmittedClaimData] = useState<any>(null)
    const updateClaim = useUpdateClaimData()

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => e.preventDefault()

    const saveFieldValue = (dataToSave: SaveValueInterface) => {
        console.log(dataToSave)
        let tempClaimObject = claimObject

        if (tempClaimObject) {
            tempClaimObject[dataToSave.field] = dataToSave.value
        }

        setClaimObject(tempClaimObject)
        // console.log("CLAIM OBJECT: ", claimObject);

        const validated = fieldValidation(dataToSave)

        if (validated.success) {
            return validated
        } else {
            return validated
        }
    }

    const activeGroupAssignment = async (group: string) => {
        console.log('next group to display: ', group)
        console.log('CLAIM OBEJECT : ', claimObject)

        const flowOrder = ['person', 'contact', 'address', 'review', 'signature', 'complete']
        const currentIndex = flowOrder.indexOf(activeGroup)
        const nextIndex = flowOrder.indexOf(group)

        // The signature step requires a successful lead upload first. Run it BEFORE
        // advancing so a validation failure keeps the user on the review page with
        // the error shown, instead of silently moving them on to the e-sign step.
        if (group === 'signature') {
            if (SKIP_LEAD_UPLOAD) {
                // DEV: bypass the upload and inject mock signing data so the signature step renders
                updateClaim({
                    ...claimObject,
                    leadOrigin: LEAD_ORIGIN,
                    leadSource: LEAD_SOURCE,
                    sigData: { token: 'dev-mock-token' },
                })
            } else if (submittedClaimData) {
                // Lead was already submitted in this session (e.g. the user went back
                // from e-sign and returned). Re-use the first submission's data instead
                // of re-posting — re-posting would hit the backend duplicate-client
                // guard and show the "No Additional Claims" message.
                updateClaim({
                    ...submittedClaimData,
                    leadOrigin: LEAD_ORIGIN,
                    leadSource: LEAD_SOURCE,
                })
            } else {
                let claimData: any
                try {
                    claimData = await uploadDataToServer(claimObject)
                } catch (error) {
                    console.error('[MFC-FORM] Error uploading data before signature:', error)
                    return
                }
                // uploadDataToServer surfaces the error to the user itself; if it
                // didn't succeed we stay on the review page rather than advancing.
                if (!claimData || claimData.success === false || !claimData.claimData) {
                    console.warn('[MFC-FORM] lead upload failed — staying on review page')
                    return
                }
                // Remember the result so a later return to this step skips re-posting.
                setSubmittedClaimData(claimData.claimData)
                updateClaim({
                    ...claimData.claimData,
                    leadOrigin: LEAD_ORIGIN,
                    leadSource: LEAD_SOURCE,
                })
            }
        } else if (group === 'review') {
            updateClaim({
                ...claimObject,
                leadOrigin: LEAD_ORIGIN,
                leadSource: LEAD_SOURCE,
            })
        }

        if (activeGroup === 'address' && nextIndex > currentIndex) {
            setShowInfoBox(false)
        }

        setActiveGroup(group)
        window.scrollTo(0, 0)
        setGroupsComplete(nextIndex !== currentIndex ? nextIndex : groupsComplete)
    }

    useEffect(() => {
        // Calculate percentage based on the total number of steps
        // flowOrder has 6 steps, so each step is worth 100/5 = 20% (we subtract 1 because we start at 0%)
        const totalSteps = 5 // Total number of transitions in the flow
        const rawPercentage = Math.round((groupsComplete / totalSteps) * 100)
        const newPercentage = groupsComplete === 0 ? 5 : groupsComplete === 4 ? 95 : Math.min(rawPercentage, 100)
        setActualPercentage(newPercentage)
    }, [groupsComplete])

    useEffect(() => {
        if (displayedPercentage === actualPercentage) return

        const isCountingUp = displayedPercentage < actualPercentage

        const animationInterval = setInterval(() => {
            setDisplayedPercentage((prev) => {
                if (isCountingUp) {
                    return prev < actualPercentage ? prev + 1 : actualPercentage
                } else {
                    return prev > actualPercentage ? prev - 1 : actualPercentage
                }
            })
        }, 20)

        return () => clearInterval(animationInterval)
    }, [actualPercentage, displayedPercentage])

    const isComplete = activeGroup === 'openBanking'

    return (
        <div style={isComplete ? { minHeight: '100vh', display: 'flex', flexDirection: 'column' } : undefined}>
            <FloatingInfoBox
                position="right"
                showBox={showInfoBox}
                message={
                    <>
                        Quick & easy
                        <br />
                        Just 60 seconds!
                    </>
                }
            />

            <div className={`${styles.formContainer} ${responsiveStyles.formContainer}`}>
                <div className={`${styles.formTitle} ${responsiveStyles.formTitle}`}>
                    {groupsComplete > 4 || activeGroup === 'openBanking' ? (
                        <h1>
                            Great news <br /> your PCP claim review is underway.
                        </h1>
                    ) : (
                        <h1>
                            Register <span style={{ backgroundColor: '#00bf63', color: '#fff', padding: '0 6px', borderRadius: '4px', display: 'inline-block', transform: 'translateY(2px)' }}><span style={{ display: 'inline-block', transform: 'translateY(-2px)' }}>your</span></span> <br />
                            Mis-sold Vehicle Finance Claim
                        </h1>
                    )}

                    {groupsComplete === 0 && activeGroup !== 'openBanking' && (
                        <div className={styles.compensationText}>
                            <p className={styles.compensationLine1}>You could be owed compensation</p>
                            <p className={styles.compensationLine2}>with a per client average value of</p>
                            <p className={styles.amount}>£5,318*</p>
                        </div>
                    )}

                    {activeGroup !== 'openBanking' && (
                        <div
                            className={`${styles.percentageProgressContainer} ${responsiveStyles.percentageProgressContainer}`}
                        >
                            <div className={styles.progressHeader}>
                                {activeGroup !== 'person' ? (
                                    <button
                                        className={styles.progressBackButton}
                                        onClick={() => {
                                            const flowOrder = ['person', 'contact', 'address', 'review', 'signature', 'complete']
                                            const prevStep = flowOrder[flowOrder.indexOf(activeGroup) - 1]
                                            if (prevStep) activeGroupAssignment(prevStep)
                                        }}
                                    >
                                        Back
                                    </button>
                                ) : (
                                    <span />
                                )}
                                <span className={styles.percentageProgressText}>
                                    Step {groupsComplete + 1} of 5
                                </span>
                            </div>
                            <div className={styles.percentageProgressBar}>
                                <div
                                    className={styles.percentageProgressFill}
                                    style={{
                                        width: `${displayedPercentage}%`,
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
                <form className={`${styles.form}`} onSubmit={(e) => handleSubmit(e)}>
                    <div className={styles.formFields}>
                        <Address
                            saveValueFunct={saveFieldValue}
                            isActive={activeGroup}
                            assignGroup={activeGroupAssignment}
                        />
                        <Person
                            saveValueFunct={saveFieldValue}
                            isActive={activeGroup}
                            assignGroup={activeGroupAssignment}
                        />
                        <ContactDetails
                            saveValueFunct={saveFieldValue}
                            isActive={activeGroup}
                            assignGroup={activeGroupAssignment}
                        />
                        <Review
                            saveValueFunct={saveFieldValue}
                            isActive={activeGroup}
                            assignGroup={activeGroupAssignment}
                        />
                        <SignatureSentinel
                            saveValueFunct={saveFieldValue}
                            isActive={activeGroup}
                            assignGroup={activeGroupAssignment}
                        />
                        <OpenBankingStep
                            isActive={activeGroup}
                            saveValueFunct={saveFieldValue}
                            assignGroup={activeGroupAssignment}
                        />
                        {/* <Complete
                            isActive={activeGroup}
                            saveValueFunct={saveFieldValue}
                            assignGroup={activeGroupAssignment}
                        /> */}
                    </div>

                    {groupsComplete > 0 && groupsComplete <= 4 && activeGroup !== 'openBanking' && (
                        <div className={styles.compensationText}>
                            <p className={styles.compensationLine1}>You could be owed compensation</p>
                            <p className={styles.compensationLine2}>with a per client average value of</p>
                            <p className={styles.amount}>£5,318*</p>
                        </div>
                    )}
                </form>
            </div>
            {!isComplete && <DottedBackground height={200} />}

            {!isComplete && <div className={styles.socialProofStrip}>
                <span className={styles.socialProofLabel}>As seen on</span>
                <NewsBanner items={newsItems} speed="fast" height={60} backgroundColor="transparent" textColor="#555" />
            </div>}

            {!isComplete && <div className={styles.eligibilitySectionWrapper}>
                <EligibilitySection />
            </div>}

            {!isComplete && <div className={styles.dualVideoContainer}>
                <h3 className={styles.dualVideoTitle}>Watch Sentinel Legal discuss mis-sold vehicle finance</h3>
                <div className={styles.videoGrid}>
                    <div className={styles.videoSection}>
                        <div className={styles.videoTitle}>
                            <span>Sentinel Legal on</span>
                            <img src={skyNews} alt="Sky News" className={styles.newsLogo} />
                        </div>
                        <div className={styles.videoWrapper}>
                            <iframe
                                width="100%"
                                height="100%"
                                src="https://www.youtube.com/embed/vzQ8qgvxV0U"
                                title="Sentinel Legal on Sky News"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                    </div>
                    <div className={styles.videoSection}>
                        <div className={styles.videoTitle}>
                            <span>Sentinel Legal on</span>
                            <img src={gbn} alt="GB News" className={styles.newsLogo} />
                        </div>
                        <div className={styles.videoWrapper}>
                            <iframe
                                width="100%"
                                height="100%"
                                src="https://www.youtube.com/embed/DzSiw4xWm78"
                                title="Sentinel Legal on GB News"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                    </div>
                </div>
            </div>}

            {/* <div
                style={{
                    marginTop: 40,
                    marginBottom: 40,
                    padding: '40px 0',
                    backgroundColor: 'transparent',
                    background: 'transparent',
                }}
            >
                <h3 style={{ textAlign: 'center', marginBottom: 30, color: '#333' }}>What Our Customers Say</h3>
                <div className={styles.testimonialSection}>
                    <Testimonials />
                </div>
            </div> */}
        </div>
    )
}

export default ClaimFormMailReferral
